export const notFoundData = 
  {
    name: "Seite wurde nicht gefunden",
    description: "diese seite wurde entweder entfernet oder umbenannt",
    btn:"Zurück zur Startseite",
  };
